import React, { Fragment, useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components

import Form from '../../../lib/wrappers/Form';
import UniversalInput from '../../../lib/wrappers/UniversalInput';
import ValidationErrorMessage from '../notifications/ValidationErrorMessage';

// ActionCreators

import { changeData } from '../../../actions/ssap/ssapActionCreators';

// Utils

import { cloneObject } from '../../../utils/miscellaneous/cloneObject';
import { dataSyncingTools } from '../../../utils/tools/dataSyncingTools';
import { normalizeNameOfPerson } from '../../../utils/normalize/normalizeNameOfPerson';
import { preventerTools } from '../../../utils/tools/preventerTools';
import { getDateDifference } from '../../../utils/dates/date.utils';

// Constants

import { DROPDOWN_OPTIONS, getDynamicDropdownNumberOption, getOptionsForHardcodedState } from '../../../constants/ssap/hhmTypes/dropdownOptions';
import { EMPTY_OBJECTS } from '../../../constants/ssap/initialValues/emptyObjects';
import { GENDER_TYPES } from '../../../constants/ssap/miscellaneous/miscellaneous';
import { INPUT_TYPES } from '../../../constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '../../../constants/inputs/validationTypes';
import { VALIDATION_ERROR_MESSAGES } from '../../../constants/inputs/validationErrorMessages';






/**
 *
 * @param {Object} props
 * @returns {React.Component} - 'Additional Information - Member Preganant Details ' Page
 *
 */
const Page2_24 = props => {

    const AGE_LIMIT = 21;

    const {
        data,
        data: {
            taxHousehold: {
                thCommonParams: {
                    hasSomeoneEverInFosterCare
                }
            }
        },
        environment: {
            localDates: {
                serverDate
            },
            stateCode
        },
        form,
        formName,
        householdMembers
    } = props;

    const {
        isFormSubmitted
    } = preventerTools.provideObject(form[formName]);

    const onFieldChange_member = (...args) => {

        let [newData, indexInArray, , [name, value]] = args;

        const newState = { ...data };
        const { dateOfBirth } = householdMembers[indexInArray];

        const {
            ageWhenLeftFosterCare,
            fosterCareState
        } = newData.specialCircumstances;

        const age = getDateDifference(serverDate, dateOfBirth, 'year');

        if(value && name === 'everInFosterCareIndicator') {
            newData.specialCircumstances = {
                ...newData.specialCircumstances,
                fosterCareState: stateCode,
                ageWhenLeftFosterCare: age > AGE_LIMIT ? AGE_LIMIT : age
            };
        }

        const ss = newState.taxHousehold.householdMember[indexInArray].specialCircumstances;
        if (!newState.taxHousehold.householdMember[indexInArray].specialCircumstances.everInFosterCareIndicator) {
            newState.taxHousehold.householdMember[indexInArray].specialCircumstances = {
                ...ss,
                ...cloneObject(EMPTY_OBJECTS.FOSTER_CARE)
            };
        } else {
            newState.taxHousehold.householdMember[indexInArray] = newData;
            if(ageWhenLeftFosterCare > 0 && fosterCareState) {
                if((age <= 25 && ageWhenLeftFosterCare === 18 && stateCode === fosterCareState) || (age <= 21 && ageWhenLeftFosterCare === 18 && stateCode!== fosterCareState)) {
                    newState.taxHousehold.householdMember[indexInArray].specialCircumstances.metFosterCareConditions = true;
                } else {
                    newState.taxHousehold.householdMember[indexInArray].specialCircumstances.metFosterCareConditions = false;
                }
            } else {
                newState.taxHousehold.householdMember[indexInArray].specialCircumstances.metFosterCareConditions = false;
            }

        }

        const syncedData = dataSyncingTools.syncThCommonProps(
            newState,
            { propName: 'foster' }
        );

        props.actions.changeData(syncedData);
    };

    const onFieldChange_none_of_above = (...args) => {

        const [ newData ] = args;

        newData.taxHousehold.householdMember = newData.taxHousehold.householdMember.map(member => {
            member.specialCircumstances = {
                ...member.specialCircumstances,
                ...cloneObject(EMPTY_OBJECTS.FOSTER_CARE)
            };
            return member;
        });

        const syncedData = dataSyncingTools.syncThCommonProps(
            newData,
            {
                isCommon: true,
                propName: 'foster'
            }
        );

        props.actions.changeData(syncedData);
    };

    const getHouseholdMembers = (householdMembers) => {

        const combinedMembers = [];

        householdMembers.forEach((member, i) => {
            const {
                name,
                specialCircumstances: {
                    fosterCareState,
                    everInFosterCareIndicator,
                    gettingHealthCareThroughStateMedicaidIndicator,
                    ageWhenLeftFosterCare
                },
                dateOfBirth,
                applyingForCoverageIndicator,
                gender
            } = member;

            const memberName = `${normalizeNameOfPerson(name)}`;
            const age = getDateDifference(serverDate, dateOfBirth, 'year');
            const [ stateAbbr ] = fosterCareState ? getOptionsForHardcodedState(fosterCareState) : [{}];

            combinedMembers.push(
                <Fragment key = { `${ name.firstName }_${ i }` } >
                    {
                        applyingForCoverageIndicator &&

                        <Fragment>
                            <ul className = 'usa-list usa-list--unstyled' >
                                {
                                    age >= 18 && age <= 25 &&

                                    <li>
                                        <UniversalInput
                                            label = { {
                                                text: 'common.input.label.non_internationalized_text',
                                                labelTextReplacements: {
                                                    text: memberName
                                                }
                                            } }
                                            inputData = { {
                                                isInputRequired: false,
                                                type: INPUT_TYPES.CHECKBOX,
                                                name: 'everInFosterCareIndicator',
                                                classes: [''],
                                                checked: everInFosterCareIndicator,
                                                value: everInFosterCareIndicator,
                                                currentData: member,
                                                fields: [ 'specialCircumstances' ]
                                            } }
                                            inputActions = { {
                                                onFieldChange: onFieldChange_member
                                            } }
                                            indexInArray = { i }
                                            errorClasses = { [ 'margin-l-0' ] }
                                        />
                                    </li>
                                }
                            </ul>

                            {
                                everInFosterCareIndicator &&

                                <Fragment>
                                    <div className = 'margin-tb-20' >
                                        <fieldset>
                                            <FormattedMessage
                                                id = 'ssap.family_household.foster_care.what_state'
                                                values = { {
                                                    personName: <strong>{ memberName }</strong>
                                                } }
                                                tagName = 'legend'
                                            />
                                            <UniversalInput
                                                label = { {
                                                    text: 'ssap.input.label.state',
                                                    isLabelRequired: true
                                                } }
                                                inputData = { {
                                                    isInputRequired: true,
                                                    type: INPUT_TYPES.DROPDOWN,
                                                    name: 'fosterCareState',
                                                    value: fosterCareState,
                                                    options: DROPDOWN_OPTIONS.STATE,
                                                    validationType: VALIDATION_TYPES.CHOSEN,
                                                    currentData: member,
                                                    fields: ['specialCircumstances']
                                                } }
                                                errorClasses = { [ 'margin-b-0' ] }
                                                inputActions = { {
                                                    onFieldChange: onFieldChange_member
                                                } }
                                                indexInArray = { i }
                                            />
                                        </fieldset>
                                        <UniversalInput
                                            legend = { {
                                                legendText: 'ssap.input.legend.getting_health_care',
                                                legendTextReplacements: {
                                                    personName: <strong>{ normalizeNameOfPerson(name) }</strong>,
                                                    stateAbbr: <strong>{ stateAbbr.text }</strong>
                                                }
                                            } }
                                            label = { {
                                                ulClass: [ 'margin-b-20' ],
                                                showRequiredIcon: true
                                            } }
                                            inputData = { {
                                                isInputRequired: true,
                                                type: INPUT_TYPES.RADIO_BUTTONS,
                                                name: 'gettingHealthCareThroughStateMedicaidIndicator',
                                                value: gettingHealthCareThroughStateMedicaidIndicator,
                                                options: DROPDOWN_OPTIONS.YES_NO,
                                                validationType: VALIDATION_TYPES.CHOSEN,
                                                currentData: member,
                                                fields: [ 'specialCircumstances' ]
                                            } }
                                            inputActions = { {
                                                onFieldChange: onFieldChange_member
                                            } }
                                            indexInArray = { i }
                                        />
                                        <fieldset>
                                            <FormattedMessage
                                                id = 'ssap.family_household.foster_care.how_old'
                                                values = { {
                                                    personName: <strong>{ memberName }</strong>,
                                                    genderPronoun: gender === GENDER_TYPES.FEMALE ?
                                                        <FormattedMessage id='common.she' /> :
                                                        <FormattedMessage id='common.he' />
                                                } }
                                                tagName = 'legend'
                                            />
                                            <UniversalInput
                                                label = { {
                                                    text: 'ssap.input.label.age',
                                                    isLabelRequired: true
                                                } }
                                                inputData = { {
                                                    isInputRequired: true,
                                                    type: INPUT_TYPES.DROPDOWN,
                                                    name: 'ageWhenLeftFosterCare',
                                                    value: ageWhenLeftFosterCare,
                                                    options: getDynamicDropdownNumberOption(age, AGE_LIMIT),
                                                    validationType: VALIDATION_TYPES.CHOSEN,
                                                    currentData: member,
                                                    handleAsNumbers: true,
                                                    fields: [ 'specialCircumstances' ]
                                                } }
                                                errorClasses = { [ 'margin-b-0' ] }
                                                inputActions = { {
                                                    onFieldChange: onFieldChange_member
                                                } }
                                                indexInArray = { i }
                                            />
                                        </fieldset>
                                    </div>
                                </Fragment>
                            }
                        </Fragment>
                    }

                </Fragment>
            );

        });

        combinedMembers.push(
            <UniversalInput
                key = 'hasSomeoneEverInFosterCare'
                label = { {
                    text: 'ssap.input.label.none_of_above',
                    isLabelRequired: false
                } }
                inputData = { {
                    isInputRequired: false,
                    type: INPUT_TYPES.CHECKBOX,
                    name: 'hasSomeoneEverInFosterCare',
                    checked: hasSomeoneEverInFosterCare === false,
                    value: hasSomeoneEverInFosterCare === false,
                    currentData: cloneObject(data),
                    fields: [ 'taxHousehold', 'thCommonParams' ],
                    reversedValue: true
                } }
                inputActions = { {
                    onFieldChange: onFieldChange_none_of_above
                } }
            />
        );
        return combinedMembers;
    };

    const topLevelValidity = useMemo(
        () => {
            return householdMembers.some(hhm => hhm.specialCircumstances.everInFosterCareIndicator)
                || hasSomeoneEverInFosterCare === false;
        },
        [ householdMembers, hasSomeoneEverInFosterCare ]
    );

    return (
        <Fragment>
            <div
                className = 'fade-in'
                id = 'fhMoreInfo'
            >
                <div className = 'subsection' >
                    <Form
                        { ...{
                            formName,
                            topLevelValidity
                        } }
                    >
                        <p className = 'required-true' >
                            <FormattedMessage id = 'ssap.family_household.foster_care.was_anybody_on_foster_care' />
                        </p>
                        <ValidationErrorMessage
                            isVisible = { isFormSubmitted && !topLevelValidity }
                            messageText = { VALIDATION_ERROR_MESSAGES.ANY_VALUE }
                            errorClasses = { [ 'margin-l-0' ] }
                        />
                        {
                            getHouseholdMembers(householdMembers)
                        }
                    </Form>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,

    data: state.ssap.data,
    form: state.ssap.form,

    householdMembers: state
        .ssap
        .data
        .taxHousehold
        .householdMember
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Page2_24);
